import {Condition} from '../biotwin/types';

export interface Tenant {
  biotypeLimit: number;
  biotypeNameMask: string | null;
  biotypeNamePattern: string | null;
  id: number;
  tenantName: string;
  userLimit: number;
  usesIntegration: boolean;
}

export interface TenantUser {
  accountCreatedBy?: string;
  accountCreatedAt: string;
  id: number;
  email: string;
  name: string;
  username: string;
}

export interface TenantInvitation {
  createdAt: string;
  id: number;
  email: string;
  message: string;
  status: TenantInvitationStatus;
}

export enum TenantInvitationStatus {
  Pending = 1,
  Accepted = 2,
  Timeout = 3,
}

export interface TenantBiotwinCount {
  date: string;
  count: number;
}

export interface TenantPatientInfo {
  isAllProcessed: boolean;
  items: TenantPatientInfoItem[];
}

export enum TenantPatientInfoItemCodeType {
  Disease = 1,
  Drug = 2,
  FamilyHistory = 3,
  Allergy = 4,
  Test = 5,
}

export interface TenantPatientInfoItem {
  code: string;
  codeName: string;
  codeType: TenantPatientInfoItemCodeType;
  condition: Condition | null;
  date: string;
  isChronic: boolean;
  isProcessed: boolean;
  value: string | null;
}
